import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import arSA from 'date-fns/locale/ar-SA'
import enUS from 'date-fns/locale/en-US'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormTextField from '../FormTextField'
import FormEntityLoadField from '../FormEntityLoadField'
import FormDateField from '../FormDateField'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak'
import LinkIcon from '@material-ui/icons/Link'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'


const EGSCodeUsageForm = ({ currentData, onSubmit, locale, cancelDialog, currentAction, codeUsageUniqueID, updateParentEntity,currentCodeLoading }) => {
  const classes = formStyles()

  const formActions = useFormik({
    initialValues: {
      codeDescriptionPrimaryLang: '',
      codeDescriptionSecondaryLang: '',

      activeTo: null,

      linkedCode: '',
      linkedCodeId: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers, null, codeUsageUniqueID, null, null, true, updateParentEntity)
    })
  })

  const [dateTo, setDateTo] = React.useState(null)

  React.useEffect(() => {
      if (!!Object.keys(currentData || {}).length) {
        formActions.setValues({
          codeDescriptionPrimaryLang: currentData?.details?.description_en || '',
          codeDescriptionSecondaryLang: currentData?.details?.description_ar || '',

          activeTo: currentData?.details?.activeTo ? new Date(currentData?.details?.activeTo) || null : null,

          linkedCode: '',
          linkedCodeId: currentData?.details?.linkedCode || null,
          requestReason: ''
        })
        setDateTo(currentData?.details?.activeTo ? new Date(currentData?.details?.activeTo) || null : null)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentData])

  const handleDateChange = (date, fieldName, setDate) => {
    setDate(date)
    formActions.setFieldValue(fieldName, date || '')
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
      <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

        <FormTextField name={'codeDescriptionPrimaryLang'} labelKey={'Fields.label.view.Code.description_en'}
                       classes={classes}
                       formActions={formActions} lines={2}/>
        <FormTextField name={'codeDescriptionSecondaryLang'} labelKey={'Fields.label.view.Code.description_ar'}
                       classes={classes}
                       formActions={formActions} lines={2}/>

        <ListingProvider entityName={'codesSearch'} codeType={'EGS'}
                         codeTypeChanged={'EGS'} disableDefaultSearch
                         listingPaging={{
                           Ps: 100,
                           Pn: 1,
                           ApplyMinChoiceLevel: true,
                           CodeTypeLevelNumber: 5
                         }}>
          <ListingConsumer>
            {({ listingData, listingLoading, handleListingFilterSubmit }) => (
              <FormEntityLoadField formActions={formActions} classes={classes} name={'linkedCode'}
                                   optionKey={'codeLookupValue'} row onlySearchBtn
                                   entityKey={'codeLookupValue'} loading={listingLoading} list={listingData}
                                   searchable={'CodeLookupValue'} loadEntities={handleListingFilterSubmit}
                                   labelKey={'Fields.label.view.Code.linkedCode.label'} codeSearch={'EGS'}
                                   getOptionLabel={(option) => !!option?.codeLookupValue ? `${locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang} (${option.codeLookupValue})` || '' : ''}
                                   renderOption={(option, selected) => {
                                     return <React.Fragment>
                                       {!!option.codeLookupValue &&
                                       <div className={classes.optionWrapper}>
                                         <CenterFocusWeakIcon color={'primary'}/>
                                         <div className={classes.optionContainer}>

                                           <div className={classes.optionParent}>
                                             {(!!option.parentCodeNamePrimaryLang ||
                                               (locale === 'ar' && !!option.parentCodeNameSecondaryLang)) ?
                                               (locale === 'ar' ? option.parentCodeNameSecondaryLang || option.parentCodeNamePrimaryLang : option.parentCodeNamePrimaryLang)
                                               : <FormattedMessage id={'codesSearch.NoParent'}/>}
                                           </div>
                                           <div className={classes.option}>
                                             {locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang}
                                             <span className={classes.optionID}>
                                                     ({option.codeLookupValue})
                                                   </span>
                                           </div>
                                         </div>
                                       </div>
                                       }
                                     </React.Fragment>
                                   }}/>
            )}
          </ListingConsumer>
        </ListingProvider>
        {!!formActions.values.linkedCodeId &&
        <Typography paragraph variant={'body2'} className={classes.createEGSLinkWrapper}>
          <LinkIcon color={'secondary'}/><FormattedMessage id='oldLinkedCodeID' values={{
          code: formActions.values.linkedCodeId,
          removeLink: <Button size={'small'} variant={'outlined'} color={'secondary'} disableRipple className={classes.removeLinkedCodeLink}
                              onClick={() => formActions.setFieldValue('linkedCodeId', '')}><HighlightOffIcon/>
            <FormattedMessage
              id='oldLinkedCodeID.RemoveLink'/></Button>
        }}/>
        </Typography>}

        <FormDateField name={'activeTo'} labelKey={'Fields.label.view.Code.activeTo'}
                       classes={classes} formActions={formActions}
                       value={dateTo}
                       handleChange={(date) => handleDateChange(date, 'activeTo', setDateTo)}/>


        <div className={classes.FormSubmitRow}>
          <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                  onClick={formActions.handleSubmit}
                  disabled={formActions.isSubmitting || !formActions.isValid}
          >
            <FormattedMessage id={`AddNewDialog.AddNewRecord.${currentAction}`}/>
          </Button>
          <Button variant='outlined' color='secondary'
                  onClick={cancelDialog} className={'cancel'}>
            <FormattedMessage id='invoiceSteps.Cancel'/>
          </Button>
        </div>
        {(!!formActions.isSubmitting || !!currentCodeLoading) && <FormLoader loading={true}/>}
      </form>
    </MuiPickersUtilsProvider>
  )
}

export default EGSCodeUsageForm
